'use strict';

var Params = function Params() {
  return function (containerWidth, containerHeight, zoomScaleExtent) {
    var chartPadding = {
      top: 10,
      bottom: 35,
      left: 10,
      right: 50
    };
    var height = containerHeight - (chartPadding.top + chartPadding.bottom);
    return {
      zoomScaleExtent: zoomScaleExtent,
      width: containerWidth,
      height: height,
      chartPadding: chartPadding,
      xAxisLabelOffset: 40,
      yAxisOffset: 5,
      yAxisLabelOffset: 15,
      yAxisTicks: 5
    };
  };
};
Params.$inject = [];
module.exports = Params;